export function appendStyleElement(styles) {
  const element = document.createElement('style');
  element.textContent = styles;
  document.head.appendChild(element);
  return element;
}

export function enableElement(el) {
  el.disabled = false;
}

export function disableElement(el) {
  el.disabled = true;
}

export function hideElement(el) {
  el.classList.add('hidden');
}

export function showElement(el) {
  el.classList.remove('hidden');
}

export function showOrHideElement(el, isShow) {
  (isShow ? showElement : hideElement)(el);
}

export function uncheckList(list) {
  for (let i = 0; i < list.length; i++) {
    list[i].checked = false;
  }
}
